import React from 'react';
import AlertModal from './AlertModal';

const ErrorAlertModal = ({ open, handleClose, title = "Error", message, onConfirm }) => {
  return (
    <AlertModal
      open={open}
      handleClose={handleClose}
      title={title}
      message={message}
      onConfirm={onConfirm}
      variant="error"
    />
  );
};

export default ErrorAlertModal;